var dynamicRequire = require('../dynamicRequire');
var React = dynamicRequire('react');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');
var SVGIcon = dynamicRequire('SVGIcon.jsx');

class ColorPicker extends React.Component {
    render() {
        var selectedColor = this.getSelectedColor();
        var colorName = resolveLanguage('nc_casefactory.color.'+selectedColor.colorName);
        var ral = /(RAL\d{4})/.exec(selectedColor.name);
        var colorAndRal = colorName  + (ral?' ('+ral[1]+')':'');
        return <div className="lr-casefactory-choices-color-picker color-picker">
            <strong className="headline">
                <Mssg __key="nc_casefactory.chosen.color" />:<br/><span dangerouslySetInnerHTML={{__html:colorAndRal}}></span>
            </strong>
            {this.hasPolyBoardPanels() ? this.getPanels(this.getPolyBoardPanels(), 'nc_casefactory.choose.polyboard') : ''}
            {this.hasWoodPanels() ? this.getPanels(this.getWoodPanels(), 'nc_casefactory.choose.birkenmultiplex') : ''}
            {this.hasPvcPanels() ? this.getPanels(this.getPvcPanels(), 'nc_casefactory.choose.wabenkunststoff') : ''}
        </div>
    }

    getPolyBoardPanels(){
        return this.getColors().filter((color) => {
            return color.name.indexOf('Poly-Board')!==-1;
        }).sort((color1, color2) => {
            return color1.id > color2.id?1:-1;
        });
    }

    getWoodPanels(){
        return this.getColors().filter((color) => {
            return color.name.indexOf('Birke')!==-1;
        }).sort((color1, color2) => {
            return color1.id > color2.id?1:-1;
        });
    }

    getPvcPanels(){
        return this.getColors().filter((color) => {
            return color.name.indexOf('Wabenkunststoff')!==-1;
        }).sort((color1, color2) => {
            return color1.id > color2.id?1:-1;
        });
    }

    getSelectedColor() {
        return this.getColors().filter((color) => {
            return color.id == this.props.case.PANEL
        })[0];
    }

    getColors() {
        return this.props.possibleParts.filter((possiblePart, index, array) => {
            return possiblePart.category == 'PANEL';
        });
    }

    hasPolyBoardPanels() {
        return this.getPolyBoardPanels().length;
    }

    hasWoodPanels() {
        return this.getWoodPanels().length;
    }

    hasPvcPanels() {
        return this.getPvcPanels().length;
    }

    getPanels(panels, explanationKey) {
        return <div>
            <p className="lr-casefactory-choices-color-picker-explaination explanation">
                <Mssg __key={explanationKey} />
            </p>
            <div className="lr-casefactory-choices-color-picker-colors-colors colors">
                {panels.map(panel => {
                    var classes = "lr-casefactory-choices-color-picker-colors-color color" + (this.isBright(panel.color)?" bright":"") + (panel.id==this.props.case.PANEL?' lr-casefactory-choices-color-picker-colors-color-active active':'')
                    return <span
                        onClick={() => {this.context.emitter.emit('color', panel)}}
                        key={panel.id}
                        className={classes}
                        style={{'backgroundColor': panel.color}}><SVGIcon identifier={'haken'}/>
                            </span>
                })}
            </div>
        </div>
    }

    isBright(color){
        if(color === "#f5f7f7") {
            return true;
        }else{
            return false;
        }
    }
}

ColorPicker.contextTypes = {
    emitter: React.PropTypes.object.isRequired
};


module.exports = ColorPicker;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/ColorPicker.jsx